import React, { useState } from "react";
import Swal from "sweetalert2";

const initialProducts = [
  { name: "Manzanas Orgánicas", category: "Frutas", price: "$2.50", stock: 150 },
  { name: "Carne de Res Alimentada con Pasto", category: "Carne", price: "$12.99", stock: 80 },
  { name: "Pan Integral", category: "Panadería", price: "$3.75", stock: 120 },
  { name: "Huevos de Gallinas Libres", category: "Lácteos", price: "$4.25", stock: 200 },
  { name: "Leche de Almendras", category: "Lácteos", price: "$3.50", stock: 100 },
];

const ProductTable = ({ onEdit }) => {
  const [products, setProducts] = useState(initialProducts);

  const handleDelete = (productName) => {
    Swal.fire({
      title: `¿Estás seguro de eliminar "${productName}"?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
      customClass: {
        popup: 'bg-gray-900 text-white border border-gray-800',
        title: 'text-white',
        content: 'text-gray-300',
        confirmButton: 'bg-primary-500 hover:bg-blue-600 text-white px-4 py-2 rounded',
        cancelButton: 'bg-gray-700 hover:bg-gray-600 text-white px-4 py-2 rounded'
      },
      buttonsStyling: false
    }).then((result) => {
      if (result.isConfirmed) {
        setProducts(products.filter(p => p.name !== productName));
        Swal.fire({
          title: 'Eliminado',
          text: `"${productName}" fue eliminado`,
          icon: 'success',
          background: '#1f2937',
          color: '#f3f4f6',
          confirmButtonColor: '#3b82f6'
        });
      }
    });
  };

  return (
    <div className="overflow-x-auto bg-gray-900 rounded-md">
      <table className="table-auto w-full min-w-full divide-y divide-gray-800">
        <thead className="bg-gray-800">
          <tr>
            {["Nombre del Producto", "Categoría", "Precio", "Stock", "Acciones"].map((title) => (
              <th
                key={title}
                className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-300"
              >
                {title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-800">
          {products.map((p) => (
            <tr key={p.name}>
              <td className="px-6 py-4 text-sm font-medium text-white break-words">{p.name}</td>
              <td className="px-6 py-4 text-sm text-gray-400">{p.category}</td>
              <td className="px-6 py-4 text-sm text-gray-400">{p.price}</td>
              <td className="hidden sm:table-cell px-6 py-4 text-sm text-gray-400">{p.stock}</td>
              <td className="px-6 py-4 text-right text-sm font-medium">
                <div className="flex flex-wrap gap-2 justify-end">
                  <button
                    className="flex items-center gap-1 text-blue-400 hover:text-blue-300"
                    onClick={() => onEdit(p)}
                  >
                    <span className="material-symbols-outlined text-base">edit</span> Editar
                  </button>
                  <button
                    className="flex items-center gap-1 text-red-400 hover:text-red-300"
                    onClick={() => handleDelete(p.name)}
                  >
                    <span className="material-symbols-outlined text-base">delete</span> Eliminar
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductTable;
